import React, { Component } from 'react';
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import RefrigerantsWidget from "../../../components/RefrigerantsWidget/RefrigerantsWidget";
import ToolsWidget from "../../../components/ToolsWidget/ToolsWidget";
import Skeleton from "../../../components/Skeleton/Skeleton";
import ContentPanel from "../../../components/ContentPanel/ContentPanel";
import ContentTiles from "../../../components/ContentTiles/ContentTiles";
import store from "../../../store";
import {Helmet} from "react-helmet";

class Perishables extends Component {

  render() {
    return (
      <div className="wrapper">
          <Helmet>
              {
                  store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                      return row.rowTitle === "Learn" ? row.sections.map((section) => {
                          return section.title === "Specialty Shipments" ? section.subsections.map((subsection) => {
                                      return subsection.title === "Perishables" ? <meta name="description" content={subsection.content['seo-description']}/> : null
                                  })
                                  : null
                      }) : null
                  }) : null
              }
          </Helmet>
        <Breadcrumbs/>
        <ContentPanel
          skeleton={<Skeleton type="MAIN_PANEL"/>}
          errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
          templateUrl="./content/learn/page-components/text-block/perishables-heading.html"
        />

        <ContentTiles
          jsonDataUrl="./content/learn/page-components/article/perishables.json"
        />

        <RefrigerantsWidget pageType="Perishables" />
        <div className="mb36">
          <ToolsWidget/>
        </div>

      </div>
    )
  }
}

export default Perishables;



// WEBPACK FOOTER //
// ./src/pages/learn/specialty-shipments/Perishables.js